import { LoginErrorDetails } from '@agilox/common';
import { AuthError } from '@azure/msal-browser';

const TRACE_ID_PATTERN = /Trace ID: ([\w-]+)/;
const CORRELATION_ID_PATTERN = /Correlation ID: ([\w-]+)/;
const TIMESTAMP_PATTERN = /Timestamp: ([\d-]+ [\d:]+Z)/;

function match(message: string, pattern: RegExp): string | undefined {
	return pattern.exec(message)?.[1];
}

export function toLoginErrorDetails(error: AuthError): LoginErrorDetails {
	const message = error.errorMessage ?? '';
	return {
		correlationId: match(message, CORRELATION_ID_PATTERN) ?? (error.correlationId || undefined),
		traceId: match(message, TRACE_ID_PATTERN),
		timestamp: match(message, TIMESTAMP_PATTERN),
	};
}
